var map = {
	"./restaurant-atmosphere.svg": "d770",
	"./restaurant-bathroom.svg": "8182",
	"./restaurant-cleanliness.svg": "840c",
	"./restaurant-design.svg": "c7e5",
	"./restaurant-drinks.svg": "7a31",
	"./restaurant-food.svg": "4e51",
	"./restaurant-hookah.svg": "6a74",
	"./restaurant-location.svg": "6a4a",
	"./restaurant-music.svg": "ac19",
	"./restaurant-prices.svg": "0a95",
	"./restaurant-service.svg": "f197",
	"./restaurant-table-plan.svg": "c144",
	"./salon-atmosphere.svg": "c6e6",
	"./salon-care-products.svg": "f800",
	"./salon-cleanliness.svg": "c80c",
	"./salon-comfort.svg": "161a",
	"./salon-design.svg": "a668",
	"./salon-entertainment.svg": "a284",
	"./salon-friendliness.svg": "52ef",
	"./salon-hospitality.svg": "6b05",
	"./salon-kids-friendly.svg": "de89",
	"./salon-pet-friendly.svg": "fc08",
	"./salon-value.svg": "585b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2111";